module.exports = __webpack_public_path__ + "vue-feature.2i8d43kH.svg";